import { useMessageToState } from "./useMessageToState";

function getSelectedZone(editor: eXpress.core.IEditor) {
	return editor.selection.getCurrentZone() || undefined;
}

/** Return the selected zone */
export function useSelectedZone() {
	return useMessageToState({
		name: "useSelectedZone",
		getState: getSelectedZone,
		filterMessage: eXpress.core.isSelectedZoneChanged,
	});
}

function getLogicalSelectedPage(editor: eXpress.core.IEditor) {
	return editor.selection.getLogicalSelectedPage() || undefined;
}

/** Return the selected page */
export function useLogicalSelectedPage() {
	return useMessageToState({
		name: "useLogicalSelectedPage",
		getState: getLogicalSelectedPage,
		filterMessage: (m) =>
			eXpress.core.isSelectedZoneChanged(m) || eXpress.core.isSelectedSpreadChanged(m),
	});
}

function getCurrentSpread(editor: eXpress.core.IEditor) {
	return editor.selection.getCurrentSpread();
}

/** Return the selected spread */
export function useSelectedSpread() {
	return useMessageToState({
		name: "useSelectedSpread",
		getState: getCurrentSpread,
		filterMessage: eXpress.core.isSelectedSpreadChanged,
	});
}
